module.exports = __webpack_public_path__ + "img/icon5.8450e86c.png";